import _ from "lodash";

import MaintenanceApi from "@/api/maintenanceApi";

export default {
  state: {
    list: [],
    machinesOperations: [],
    selected: {},
    pageActiveNav: "",
    skip: 0,
    limit: 10,
    total: 0
  },
  getters: {
    getAll(state) {
      return state.list || [];
    },
    getSelected(state) {
      return state.selected;
    },
    getPageActiveNav(state) {
      return state.pageActiveNav;
    },
    getMachinesOperations(state) {
      return state.machinesOperations;
    }
  },
  actions: {
    reset: ({ commit }) => {
      commit("RESET");
    },
    setPageActiveNav({ commit }, args) {
      commit("SET_PAGEACTIVENAV", args);
    },
    addMachineOperations({ commit }, args) {
      const operations = args.operations;
      const counters = args.counters;

      operations.forEach(op => {
        const machineId = op.machineId;

        commit("ADD_MACHINE_OPERATIONS", {
          Machine_Id: machineId,
          counters,
          operation: op
        });
      });
    },
    async setSelected({ state, commit, dispatch }, value) {
      await dispatch("resetMachineOperations");

      const selected = _.filter(state.list, function (item) {
        return item.uuid === value;
      });

      if (selected.length === 1) {
        // Get Maintenance detail
        dispatch("addMachineOperations", selected[0]);
        commit("SET_SELECTED", selected[0]);
      } else {
        commit("SET_SELECTED", null);
      }
    },
    async resetMachineOperations({ commit }) {
      commit("RESET_MACHINE_OPERATIONS");
    },
    async subscribe({ state, commit, rootGetters }) {
      const api = new MaintenanceApi(rootGetters["User/getUser"].OrganizationCode);
      const search = {
        skip: 0, //state.skipGroup,
        limit: 1000, //state.limit
        type: "PROGRAMMED" //o CATALOG
      };

      const response = await api.getAllMaintenance(search);

      commit("SET_ALL_LIST", response.result);
      state.total = response.total;
    },

    async addItem({ dispatch, rootGetters }, task) {
      const api = new MaintenanceApi(rootGetters["User/getUser"].OrganizationCode);
      const taskAdd = {
        maintenance: task.maintenance,
        operations: task.operationsAdd
      };
      try {
        await api.addTask(taskAdd);
        dispatch(
          "Alert/setVal",
          { message: "", result: { label: "misc.saved_ok" } },
          { root: true }
        );
      } catch (error) {
        dispatch(
          "Alert/Errors/setVal",
          { message: "", result: { label: "errors.error_generic" } },
          { root: true }
        );
      } finally {
        dispatch("reset");
        dispatch("subscribe");
      }
    },

    async updateItem({ dispatch, rootGetters }, task) {
      const api = new MaintenanceApi(rootGetters["User/getUser"].OrganizationCode);
      const taskAdd = {
        maintenance: task.maintenance,
        operations: task.operationsAdd
      };
      const taskDel = {
        maintenance: task.maintenance,
        operations: task.operationsDel
      };
      try {
        await api.addTask(taskAdd);
        taskDel.maintenance.uuid = taskDel.maintenance.id;
        await api.deleteTask(taskDel);
        dispatch(
          "Alert/setVal",
          { message: "", result: { label: "misc.updated_ok" } },
          { root: true }
        );
      } catch (error) {
        dispatch(
          "Alert/Errors/setVal",
          { message: "", result: { label: "errors.error_generic" } },
          { root: true }
        );
      } finally {
        dispatch("reset");
        dispatch("subscribe");
      }
    },

    async deleteItem({ state, commit, dispatch, rootGetters }, task) {
      // DELETE
      const api = new MaintenanceApi(rootGetters["User/getUser"].OrganizationCode);
      let new_list;
      try {
        await api.deleteTask(task);
        new_list = _.reject(state.list, function (g) {
          return g.uuid === task.maintenance.uuid;
        });

        // Update list
        commit("SET_ALL_LIST", new_list);

        // Alert ok
        dispatch(
          "Alert/setVal",
          { message: "", result: { label: "misc.deleted_ok" } },
          { root: true }
        );

        return true;
      } catch (e) {
        return false;
      }
    }
  },
  mutations: {
    RESET_MACHINE_OPERATIONS: state => {
      state.machinesOperations = [];
    },
    ADD_MACHINE_OPERATIONS: (state, payload) => {
      state.machinesOperations.push(payload);
    },
    SET_ALL_LIST: (state, payload) => {
      state.list = payload;
    },
    SET_SELECTED: (state, payload) => {
      state.selected = payload;
    },
    SET_PAGEACTIVENAV: (state, payload) => {
      state.pageActiveNav = payload;
    },
    RESET: state => {
      state.list = [];
      state.selected = {};
      state.pageActiveNav = "";
      state.skip = 0;
      state.limit = 10;
      state.total = 0;
      state.machinesOperations = [];
    }
  },
  namespaced: true
};
